define('NVT.anuualupdateform.what_each_role_means.View'
, [
    'Backbone'
  , 'nvt_what_each_role_means.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'


  ]
, function
  (
    Backbone
  , nvt_what_each_role_means_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils

  )
{
  'use strict';

    return Backbone.View.extend({
           

        template: nvt_what_each_role_means_tpl

       , title: Utils.translate('What Each Role Means?')


        ,initialize: function(options)
            {
                this.options = options;
                this.profile= options.profile;
                this.application = options.application;
                this.page_header = Utils.translate('What Each Role Means?');
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }
            
        ,getContext: function() {
            
            return {
               title : this.page_header
              
           }
         }        

    });
});
